// extracted by mini-css-extract-plugin
export default {"loginLayout":"LoginLayout_loginLayout__0IZtW","loginLayout__logo":"LoginLayout_loginLayout__logo__7Uo+8","loginLayout__content":"LoginLayout_loginLayout__content__hbd+m"};